exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Buttons-b88f0eae .demo-b9c890e4{margin:0 0 40px 0}.Buttons-b88f0eae .demoBlock-c3896a82{width:400px;max-width:100%;padding:20px;border:1px solid #E8E8E8;border-radius:4px;margin:0 0 40px 0}\n", ""]);

// Exports
exports.locals = {
	"Buttons": "Buttons-b88f0eae",
	"demo": "demo-b9c890e4",
	"demoBlock": "demoBlock-c3896a82"
};